import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import "../components/styles/TaskFeeder.css";
import { BasicTable } from "../components/scripts/Tables";
import { ApiCall } from "../utility/ApiCalls";
import Loader from "react-loader-spinner";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HourglassBottomOutlinedIcon from "@mui/icons-material/HourglassBottomOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckIcon from "@mui/icons-material/Check";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ClearIcon from "@mui/icons-material/Clear";
// import { Button } from "../components/scripts/Button";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import Api_Call from "../ApiCall";

const TaskFeedAudit = () => {
  const [taskFeeder, setTaskFeeder] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [startBtnDisabled, setStartBtnDisabled] = useState(false);

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#333",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      // border: "1px solid #dadde9",
    },
  }));

  const handleClick = (value) => {
    sessionStorage.setItem("ActiveTaskID", value);
    window.location.href = "/ClinicalAudit";
  };

  const colums = [
    {
      width: 200,
      Header: "Auth Number",
      accessor: "Auth_ID",
      Cell: (props) => {
        return (
          <>
            <a
              class="linkText"
              onClick={() => handleClick(props.row.values.Task_ID)}
            >
              {props.row.values.Auth_ID}
            </a>
          </>
        );
      },
    },
    {
      width: 200,
      Header: "Completion Date",
      accessor: "completion_date",
    },
    {
      width: 200,
      Header: "Completion Type",
      accessor: "completion_type",
    },
    {
      width: 200,
      Header: "UM Review Type",
      accessor: "UM_review_type",
    },
    {
      width: 200,
      Header: "Work Type",
      accessor: "work_type",
    },
    {
      width: 200,
      Header: "Nurse name",
      accessor: "nurse_name",
    },
    {
      width: 200,
      Header: "Date of Service",
      accessor: "date_of_service",
    },
    {
      width: 200,
      Header: "Member Business Line",
      accessor: "member_business_line",
    },
    {
      width: 200,
      Header: "Urgency",
      accessor: "urgency",
    },
    {
      width: 200,
      Header: "Determination",
      accessor: "determination",
    },
    {
      width: 300,
      Header: "System Data Extraction",
      accessor: "Care_Management_Platform_Data_Extraction",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Care_Management_Platform_Data_Extraction ==
            "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.Care_Management_Platform_Data_Extraction ==
              "1" ? (
              <CheckIcon />
            ) : props.row.values.Care_Management_Platform_Data_Extraction ==
              "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 300,
      Header: "Clinical Records Extraction Completion Status",
      accessor: "Clinical_Records_Extraction_Completion_Status",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Clinical_Records_Extraction_Completion_Status ==
            "0" ? (
              <MoreHorizIcon />
            ) : props.row.values
                .Clinical_Records_Extraction_Completion_Status == "1" ? (
              <CheckIcon />
            ) : props.row.values
                .Clinical_Records_Extraction_Completion_Status == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 300,
      Header: "Other Systems Extraction",
      accessor: "Other_Systems_Extraction",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Other_Systems_Extraction == "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.Other_Systems_Extraction == "1" ? (
              <CheckIcon />
            ) : props.row.values.Other_Systems_Extraction == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      width: 300,
      Header: "Business Validations",
      accessor: "Business_Validations",
      Cell: (props) => {
        return (
          <>
            {props.row.values.Business_Validations == "0" ? (
              <MoreHorizIcon />
            ) : props.row.values.Business_Validations == "1" ? (
              <CheckIcon />
            ) : props.row.values.Business_Validations == "2" ? (
              <ClearIcon />
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      key: "benefit_eligibility_urgency_of_request_automation_percent",
      width: 800,
      Header: "Benefit, Eligibility and Urgency of Request Automation %",
      accessor: "benefit_eligibility_urgency_of_request_automation_percent",
    },
    {
      width: 300,
      Header: "Tasking and Documentation Automation %",
      accessor: "tasking_documentation_automation_percent",
    },
    {
      width: 300,
      Header: "Decision-Making Automation %",
      accessor: "decision_making_automation_percent",
    },
    {
      width: 300,
      Header: "Notification Automation %",
      accessor: "notification_automation_percent",
    },
    {
      width: 300,
      Header: "% of Parameters automated",
      accessor: "percent_of_parameters_automated",
    },
    // {
    //   width: 0,
    //   Header: "",
    //   accessor: "Task_ID",
    //   Cell: (props) => {
    //     return (
    //       <>
    //         <span className="hidden"> {props.row.values.Task_ID} </span>
    //       </>
    //     );
    //   }
    // }
    ,
  ];

  //https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcareui_auditfeederupdate

  async function taskFeederAPI() {
    //const res = await ApiCall({}, "vcare-ui", "vcare_taskfeederupdate");
    // const res = await ApiCall({}, "vcare-ui", "vcareui_auditfeederupdate");
    const api = new Api_Call();
    const data = await api.getData(
      "TASK_FEEDER/GET-UPDATES?module-name=auditfeed"
    );

    if (data) {
      setTaskFeeder(data.body);
    }
    setLoading(false);
  }
  async function taskfeederpocessAPI() {
    setLoading(true);
    // const res = await ApiCall({}, "vcare-ui", "vcare_taskfeederpocess");
    // const res = await ApiCall({}, "vcare-ui", "vcareui_executestepfunction");
    const api = new Api_Call();
    const data = await api.getData("TASK_FEEDER/START");
    setLoading(false);
  }

  useEffect(() => {
    // let interval = setInterval(() => {
    taskFeederAPI();
    // }, 3000);
    // return () =>{
    //   clearInterval(interval);
    // }
  }, []);

  const startProcessing = () => {
    setStartBtnDisabled(true);
    taskfeederpocessAPI();
  };

  return (
    <>
      <Box className="taskFeeder-container">
        <Box className="taskFeeder-title">
          <Box>
            <Typography variant="h4">Task Feed Audit</Typography>
          </Box>
          <Box className="taskfeeder-top-right-btns">
            <a href="/UploadPage" className="btn btn--primary">
              Upload
            </a>
          </Box>
        </Box>
        <Box className="taskFeederTable">
          {isLoading ? (
            <Box className="loaderParent">
              <Loader type="Puff" color="#00BFFF" height={100} width={100} />
            </Box>
          ) : (
            <>
              <Typography variant="subtitle2">
                Data Source : aws:s3:::vcarefaxes
              </Typography>
              <BasicTable
                columns={colums}
                tableData={taskFeeder}
                tableType="default"
              />
              {/* <ul className="legends">
                <li>
                  <CheckCircleOutlinedIcon className="complete-icon" />
                  Done
                </li>
                <li>
                  <div className="processing-icon-stop"></div>Processing
                </li>
                <li>
                  <HourglassBottomOutlinedIcon className="waiting-icon" />
                  Waiting
                </li>
                <li>
                  <WarningAmberIcon className="error-icon" />
                  Review Required
                </li>
              </ul> */}
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TaskFeedAudit;
